import { useEffect, useState } from 'react';
import { useStore } from 'effector-react';
import { $loadedScene } from '@stores/loadedStore';
import { CollapseWrapper } from '@components/Collapse';
import { CompareList } from './CompareList';
import { compareReset } from '../compareStores';
import { CompareSettings } from './CompareSettings';

type Mode = 'list' | 'setting';

export function SidebarCompare() {
  const scene = useStore($loadedScene)!;
  const [mode, setMode] = useState<Mode>('list');
  useEffect(() => {
    return () => {
      compareReset();
    };
  }, []);
  return (
    <CollapseWrapper>
      <div className="absolute inset-0 flex flex-col">
        {mode === 'list' && (
          <CompareList
            scene={scene}
            onSettingClick={() => setMode('setting')}
          />
        )}
        {mode === 'setting' && (
          <CompareSettings scene={scene} onQuitClick={() => setMode('list')} />
        )}
      </div>
    </CollapseWrapper>
  );
}

export default SidebarCompare;
